import { Container } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

import { Generic } from '../Views/Generic/Generic.styles';

export const OrderSuccess = {
  Button: styled('div')`
    width: 100%;
    height: ${theme.sizes[12]};
    margin-top: ${theme.space[4]};
  `,

  Card: styled('div')`
    width: 100%;
    height: calc(${theme.sizes[18]} * 2);
  `,

  Container: styled(Container)`
    display: grid;
    gap: ${theme.space[2]};
  `,

  Icon: styled('div')`
    width: 100%;
    height: ${theme.sizes[12]};
    margin-bottom: ${theme.sizes[3]};
  `,

  SubTitle: styled(Generic.SuccessMsg)`
    width: 100%;
    height: ${theme.sizes[9]};
    margin-bottom: ${theme.sizes[3]};
  `,

  Text: styled(Generic.SuccessMsg)`
    width: 100%;
    height: ${theme.sizes[8]};
    margin-bottom: ${theme.sizes[3]};
  `,

  Title: styled(Generic.SuccessMsg)`
    width: 100%;
    height: ${theme.sizes[10]};
    margin-bottom: ${theme.sizes[3]};
  `,
};
